import { useContext } from 'react'
import { HereMapContext } from '../components/HereMapContext'

/**
 * useHereMap provides access to the map instance and control methods.
 * Must be used inside a `HereMap` (or `LazyHereMap`) provider.
 *
 * Available properties:
 * - `map` – the underlying H.Map instance (or undefined before init)
 * - `zoomIn` / `zoomOut` – step the zoom level
 * - `resetPosition` – return to the initial center and zoom
 * - `setCenter` – move the map to a location
 * - `setViewport` – set the viewport to bounds or a center+zoom pair
 * - `getZoom` / `getCenter` – read the current zoom level or center
 * - `screenToGeo` – convert screen coordinates to a geo location
 * - `resize` – notify the map that its container size changed
 */
export const useHereMap = () => {
  const context = useContext(HereMapContext)
  if (context === null) {
    throw new Error('useHereMap must be used within a HereMap provider')
  }
  return context
}
